import { render, staticRenderFns } from "./ItembankEdit.vue?vue&type=template&id=56d8b81e&"
import script from "./ItembankEdit.vue?vue&type=script&lang=js&"
export * from "./ItembankEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports